import React from 'react';
import Avatar from 'shared/components/avatar/Avatar';
import { firstLetters } from 'utils/strings';

class ItemMeal extends React.Component {
  render() {
    return (
      <div className="timeline-item timeline-item-meal">
        <Avatar
          src={this.props.avatarImage}
          width="32"
          height="32"
          name={this.props.name}
          text={`${this.props.period} ago`}
          firstLetters={firstLetters(this.props.name)}
          url={this.props.avatarUrl}
        />
        <div className="activity-meal">
          {this.props.imageSrc && (
            <div className="activity-img">
              <img src={this.props.imageSrc} alt="Meal" />
              {this.props.imageLabel && <span>{this.props.imageLabel}</span>}
            </div>
          )}
          <div className="activity-info">
            <h4>{this.props.title}</h4>
            <p className="timeline-content">{this.props.message}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default ItemMeal;
